// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import org.mifospay.core.network.model.entity.TPTResponse
import org.mifospay.core.network.model.entity.payload.TransferPayload
import org.mifospay.core.network.model.entity.templates.account.AccountOptionsTemplate

@OptIn(InternalKtorfitApi::class)
public class _ThirdPartyTransferServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : ThirdPartyTransferService {
  override suspend fun accountTransferTemplate(): AccountOptionsTemplate {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "accounttransfers/template?type=tpt")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<AccountOptionsTemplate>(),)!! 
  }

  override suspend fun makeTransfer(transferPayload: TransferPayload): TPTResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "accounttransfers?type=tpt")
        }
        setBody(transferPayload) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<TPTResponse>(),)!! 
  }
}

public class _ThirdPartyTransferServiceProvider : ClassProvider<ThirdPartyTransferService> {
  override fun create(_ktorfit: Ktorfit): ThirdPartyTransferService = _ThirdPartyTransferServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createThirdPartyTransferService(): ThirdPartyTransferService = _ThirdPartyTransferServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
